import * as React from 'react';
import classNames from 'classnames';
import { IconsSet, IconName } from './constants';

export type IconSize =
  | 'xx-small'
  | 'x-small'
  | 'small'
  | 'small-medium'
  | 'medium'
  | 'large'
  | 'x-large'
  | 'xx-large';

export interface IconProps {
  id?: string;
  name: IconName;
  className?: string;
  size?: IconSize;
}

const Icon: React.FC<IconProps> = (props: IconProps) => {
  const { id, name, className, size = 'medium' } = props;

  if (IconsSet[name] === undefined) return null;

  const iconClass = classNames(className, 'ui-icon', `ui-icon--${size}`);

  const SelectedIcon = IconsSet[name];

  return (
    <div id={id} className={iconClass}>
      <SelectedIcon />
    </div>
  );
};

export default Icon;
